import Swiper, { Lazy, Navigation, Pagination } from 'swiper';
const swiperElement = document.querySelector('.js-collection-carousel');
if (swiperElement) {
    Swiper.use([
        Lazy,
        Navigation,
        Pagination
    ]);
    new Swiper(swiperElement, {
        pagination: {
            el: '.CollectionCarousel-pagination',
            type: 'progressbar'
        },
        navigation: {
            nextEl: '.CollectionCarousel-next',
            prevEl: '.CollectionCarousel-prev'
        },
        lazy: {
            loadPrevNext: true
        },
        slidesPerView: 1.7,
        centeredSlides: false,
        loop: false,
        spaceBetween: 15,
        breakpoints: {
            1024: {
                slidesPerView: 5.5,
                spaceBetween: 12
            }
        }
    });
}
